import React from 'react';
import PropTypes from 'prop-types';

import {OECustomCheckbox} from '../../controls/oe-checkbox';
import OETextField from '../../controls/oe-text-field';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelStringValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onDefinedPressed = this.onDefinedPressed.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
    }

    onChange(value) {
        if(this.props.onChange)   this.props.onChange(this, this.props.name, value);
    }

    render()    {
        let isDefined = this.props.value !== undefined;

        return (
            <OEObjectModelValueCell {...this.props}>
                {!this.props.undefinedEditable ? null :
                    <OECustomCheckbox
                        className="checkbox-defined"
                        disabled={this.props.disabled}
                        checked={isDefined}
                        onPressed={this.onDefinedPressed}
                    />
                }
                <OETextField
                    disabled={this.props.disabled || (this.props.undefinedEditable && !isDefined)}
                    value={this.props.value}
                    clearButton={false}
                    onChange={this.onTextChange}
                /> 
            </OEObjectModelValueCell>
        );
    }

    onDefinedPressed(sender) {
        if(!this.props.undefinedEditable)   return;
        let value_ = this.props.value !== undefined ? undefined : '';
        this.onChange(value_);
    }

    onTextChange(sender, value)    {
        let value_ = this.props.allowUndefined && value === '' ? undefined : value;
        if(value_ === this.props.value) return;
        this.onChange(value_);
    }
};

OEObjectModelStringValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             false,
    undefinedEditable:          false
}, OEObjectModelValueCell.defaultProps);

OEObjectModelStringValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    undefinedEditable:          PropTypes.bool,
    value:                      PropTypes.string
}, OEObjectModelValueCell.propTypes);